export default __webpack_public_path__ + "static/media/it-32.a382dfed.svg";